<template>
  <div style="width: 100%">
    <v-row align="center" style="max-height: 56px">
      <v-col cols="auto">
        <div class="title text--secondary text-uppercase">
          {{ $t("management.mentorship.ignore.title") }}
        </div>
      </v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="mentorshipIgnores"
      :search="search"
      class="safety-elevation-3 table-striped"
      :loading="loading || $apollo.loading"
    >
      <template v-slot:top>
        <v-row justify="end" class="ma-3">
          <v-text-field
            v-model="search"
            :label="$t('search.title')"
            class="flex-grow-1 pt-3 mr-3"
            prepend-inner-icon="search"
            single-line
            :background-color="
              $vuetify.theme.themes.light.primary | hexToRgb(0.2)
            "
            solo
            dense
            flat
            hide-details
            clearable
          />
        </v-row>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn icon @click="deleteIgnored(item.id)">
          <v-icon> delete_forever </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MentorshipIgnoresQuery from "@/graphql/queries/mentorship/MentorshipIgnores.gql";
import DeleteIgnoreMentorshipEmployeeTag from "@/graphql/mutation/mentorship/DeleteIgnoreMentorshipEmployeeTag.gql";

export default {
  data() {
    return {
      search: "",
      loading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: "id", value: "id" },
        { text: "tagId", value: "tagId" },
        { text: "employeeId", value: "employeeId" },
        { text: "reason", value: "reason" },
        { text: "", value: "action", align: "right" },
      ];
    },
  },
  methods: {
    deleteIgnored(id) {
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: DeleteIgnoreMentorshipEmployeeTag,
          variables: {
            id: id,
          },
        })
        .then(() => {
          this.$apollo.queries.mentorshipIgnores.refetch();
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  apollo: {
    mentorshipIgnores: {
      query: MentorshipIgnoresQuery,
      update(data) {
        return data.mentorshipIgnores.map((el) => {
          return {
            ...el,
            search: [el.id, el.tagId, el.employeeId, el.reason]
              .join("|")
              .toLowerCase(),
          };
        });
      },
    },
  },
};
</script>
